import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {UploaderComponent} from '../uploader/uploader.component';
import {NotificationService} from 'app/core/services/notification.service';
import {UploaderService} from '../uploader/uploader.service';
import {Router} from '@angular/router';
import {UtilService} from 'app/core/services/util.service';
import {ConfigService} from 'app/core/services/config.service';


@Component({
  selector: 'itpx-simple-uploader',
  templateUrl: './simple-uploader.component.html',
  styleUrls: ['./simple-uploader.component.css'],
})
export class SimpleUploaderComponent extends UploaderComponent implements  OnInit {
    @Input() uploadedFileName: string;
    @Input() dimensions: { width: number, height: number, comp: string };
    @Input() type: Array<any>;
    @Input() component: string;
    @Input() cancelRoute: string;
    @Input() saveRoute: string;
    @Input() imgSrc: string;
    @Input() droppedFile: File;
    @Input() name: string;
    @Input() bucket: string;
    @Input() showPreviewImg: boolean = true;
    @Input() showProgress: boolean = true;
    @Input() id: string;
    @Input() showCancelBtn: boolean = true;
    @Input() hiddeButtons: boolean = false;
    @Input() delegateSave: boolean;
    @Input() placeholder: string;
    @Input() autoSave: boolean = false;
    @Input() hidePreviewImage: boolean = false;
    @Input() giveMeOnlyTheUrl: boolean = false;
    @Input() maxFileSize: number;
    @Input() requirements: any;
    @Input() disableUploading: boolean = false;
    @Input() displayFileName: boolean = true;
    @Output() complete = new EventEmitter();
    @Output() saveFinished: EventEmitter<any> = new EventEmitter();
    @Output() unsavedData = new EventEmitter();
    @Output() onCancelEvent = new EventEmitter();
    @Output() inProgress = new EventEmitter();

  constructor(public notificationService: NotificationService,
              public uploaderService: UploaderService,
              public router: Router,
              public utilService: UtilService,
              public configService: ConfigService) {
      super(notificationService,
          uploaderService,
          router,
          utilService,
          configService
          );
  }

  ngOnInit() {
      if (!this.bucket) this.bucket = this.configService.get('aws').uploadsBucket;
  }

  public onChange(event: any) {
      this.unsavedData.emit(true);
      let file = event.target.files[0] || event.srcElement.files[0];
      this.onFileChange(file);
    }

  public onSave() {
      this.startProgress();

      this.uploaderService.storeFileDetails(this.file, this.component, this.bucket).subscribe(
           body => {
              this.details = body.data;
              this.upload({file:this.file,fileName:this.details.fileName,bucket:this.bucket});
          },
            error => this.endProgress()
        );
   }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/simple-uploader/simple-uploader.component.ts